import { Intent } from "@blueprintjs/core";
import { ButtonWithDialog } from "@focus/focusUI";
import { useMemo, useState } from "react";
import { usePhonebook } from "../../hooks/usePhonebook";
import { ROLES, useRoles } from "../../hooks/useRoles";
import { PhonebookContactForm } from "./PhonebookContactForm";
import { useMe } from "../../hooks/useMe";
import { sortAlphabetically } from "../../utils/sorting";

export const CreateContactButton = () => {
  const me = useMe();
  const { organizations, addContact } = usePhonebook();
  const { roles } = useRoles();
  const [isFormValid, setIsFormValid] = useState(false);

  const isAdmin = roles.includes(ROLES.ADMIN);
  const isOrgAdmin = roles.includes(ROLES.ORG_ADMIN);

  const availableOrganizations = useMemo(() => {
    if (!organizations) return [];

    if (isAdmin) {
      return sortAlphabetically(organizations.map((o) => o.name));
    }

    if (isOrgAdmin) {
      return sortAlphabetically(
        organizations
          .filter((o) => me?.organizations?.includes(o.name))
          .map((o) => o.name),
      );
    }

    return [];
  }, [organizations, me?.organizations, isAdmin, isOrgAdmin]);

  const canCreate = availableOrganizations.length > 0;

  const emptyContact = {
    contactName: "",
    role: "",
    phoneNumber: "",
    email: "",
    notes: "",
    organizations: [],
  };

  if (!canCreate) return null; // Do not show button

  return (
    <ButtonWithDialog
      minimal
      icon="new-person"
      tooltipText="New contact"
      intent={Intent.NONE}
      defaultContent={emptyContact}
      onAccept={(newContact) => addContact(newContact)}
      form={({ content, onUpdate }) => (
        <PhonebookContactForm
          content={content}
          onUpdate={onUpdate}
          onValidityChange={setIsFormValid}
          readOnly={false}
        />
      )}
      disableAccept={!isFormValid}
    />
  );
};
